import { Routes, Route } from "react-router-dom";
import Home from "./Pages/Home/Home";
import PropertiesList from "./Pages/Service/PropertyList";
import ProjectDetail from "./components/service/ProjectDetail";
import GeoJsonViewer from "./components/showAreas";
import Header from "./components/Header/Header";
import Layer from "./components/service/showLayers";
import Dashboard from "./Pages/Dashboard";
import MunicipalityMap from "./Pages/MunicipalityMap";
import ScoreCriteriaDashboard from "./Pages/ScoreCriteriaDashboard";
import ParcelMapPage from "./Pages/ParcelMapPage";
import ParcelsPage from "./Pages/Parcels/ParcelsPage";
import ComingSoon from "./Pages/ComingSoon/ComingSoon";


const App = () => {
  console.log("APP LOADED ✅");

  return (
    <>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/properties" element={<PropertiesList />} />
        <Route path="/layer" element={<Layer />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/projects/parcel/:parcelId" element={<ProjectDetail source="parcel" />} />
        <Route path="/services" element={<GeoJsonViewer />} />
        <Route path="/parcels" element={<ParcelsPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/municipality-map" element={<MunicipalityMap />} />
        <Route path="/score-criteria" element={<ScoreCriteriaDashboard />} />
        <Route path="/parcel-map" element={<ParcelMapPage />} />
        <Route path="/articles" element={<ComingSoon />} />
        <Route path="/news" element={<ComingSoon />} />
        <Route path="/events" element={<ComingSoon />} />
        <Route path="/scoring-system" element={<ComingSoon />} />
        <Route path="/demo" element={<ComingSoon />} />

        {/* ✅ Catch-all */}
        <Route path="*" element={<ComingSoon />} />
      </Routes>
    </>
  );
};

export default App;